import { Route } from '@angular/router';
import { DeletionComponent } from './deletion/deletion.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';

export const policiesRoutes: Route[] = [
    {
        path: 'terms-of-service',
        component: TermsOfServiceComponent,
    },
    {
        path: 'privacy',
        component: PrivacyComponent,
    },
    {
        path: 'deletion',
        component: DeletionComponent,
    },
];
